import ChatBotContainer from './ChatBotContainer';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import { getHistory, startChat, updateHeaders } from './api';
import {getSession, getToken, storeSession, storeToken} from './ulti';
import {ActionType, store} from './store.tsx';
import ChatBotNotification from './ChatBotNotification';
import useEventTracker from './trackEvent';

function App() {
  const globalStore = useContext(store);

  /**
   * @param {string[]} newMessage
   */
  const updateWelcomeMessage = (newMessage) => {
    globalStore.dispatch({type: ActionType.WELCOME_MESSAGE, payload: newMessage});
  };

  /**
   * @param {Config} config
   */
  const updateConfig = (config) => {
    globalStore.dispatch({type: ActionType.CONFIG, payload: config});
  };

  const hasInitialedRef = React.useRef(false);

  const [chatHistory, setChatHistory] = useState([]);

  useEffect(() => {
    if (hasInitialedRef.current) {
      return;
    }

    async function startNewChat() {
      // Start a new chat session
      /** @type {StartChatResponse} */
      const startChatResponse = await startChat();
      console.log('DEBUG >> startChat response', startChatResponse);

      // Store session and token from response
      storeSession(startChatResponse.SessionId);
      storeToken(startChatResponse.Token);

      // Update headers with new session and token
      updateHeaders({
        'LEGALLINK-SESSION': startChatResponse.SessionId,
        'Authorization': startChatResponse.Token,
      });

      // Update welcome message and config from response
      updateWelcomeMessage(startChatResponse.Welcome);
      updateConfig(startChatResponse.Config);
    }

    async function initializeChat() {
      try {
        const sessionId = getSession();
        const token = getToken();

        // Update headers with session and token
        updateHeaders({
          'LEGALLINK-SESSION': sessionId,
          'Authorization': token,
        });

        // Fetch chat history
        /** @type {HistoryResponse} */
        const chatHistoryResponse = await getHistory();
        console.log('DEBUG >> chatHistory response', chatHistoryResponse);
        if (chatHistoryResponse && chatHistoryResponse.RetCode === 0) {
          // Handle successful chat history fetch
          const history = chatHistoryResponse
            .AgentMessage
            .map((message) => message.Response);
          globalStore.dispatch({
            type: ActionType.CHAT_HISTORY,
            payload: history,
          });
          updateConfig(chatHistoryResponse.Config);
        } else {
          // Start a new chat session
          startNewChat();
        }
      } catch (err) {
        // Handle any errors that occur during initialization
        console.log('DEBUG >> error', err);
        startNewChat();
      }

      // Mark as initialized to prevent re-running
      hasInitialedRef.current = true;
      globalStore.dispatch({
        type: ActionType.INITIALIZED,
        payload: true,
      });
    }

    console.log('DEBUG >> process.env.NODE_ENV', process.env.NODE_ENV)
      console.log('DEBUG >> process.env.REACT_APP_BUILD_ENV', process.env.REACT_APP_BUILD_ENV)

    // Invoke the async function
    initializeChat();
  }, []);

  const toggleChatBotHandler = () => {
    globalStore.dispatch({
      type: ActionType.CHAT_BOT_CONTAINER_TOGGLE,
      payload: !globalStore.state.chatBotContainerToggle
    });
  };

  const getSessionId = useCallback(
      () => {
          return getSession();
      },
      [],
  );

  useEventTracker();

  return (
    <div className="App">
      <ChatBotContainer display={globalStore.state.chatBotContainerToggle}/>
      <ChatBotNotification toggleHandler={toggleChatBotHandler}
                           display={!globalStore.state.chatBotContainerToggle}/>
    </div>
  );
}

export default App;
